import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Link from '@rad/components/utility/link';
const HubCard = (props) => {
    const { label, icon, href, subtitle } = props;
    return (_jsx(Link, { href: href, className: "text-decoration-none", children: _jsx("div", { className: "hub-card card h-100 border shadow-sm", children: _jsxs("div", { className: "card-body d-flex flex-column align-items-center justify-content-center text-center p-4", children: [_jsx("i", { className: `bi ${icon} hub-card__icon mb-2` }), _jsx("div", { className: "fw-semibold text-body", children: label }), subtitle && (_jsx("small", { className: "text-body-secondary mt-1", children: subtitle }))] }) }) }));
};
export default HubCard;
